import OrderPricesCalculator from "./OrderPricesCalculator.js";
import OrderInvoiceDataPopup from "./OrderInvoiceDataPopup.js";

export default class Order {
  constructor() {
    if (this.vars()) {
      this.setupEvents();
    }
  }

  vars() {
    this.form = document.getElementById("dashboardMakeOrder");

    if (!this.form) return;

    this.action = this.form.getAttribute("action");
    this.submit = document.getElementById("payButton");
    this.checkAction = this.form.getAttribute('data-check');

    this.advertiseInputs = this.form.querySelectorAll(".advertise-array");
    this.productsInputs = this.form.querySelectorAll(".products-select");

    this.advertisesArray = [];
    this.productsArray = [];

    this.checkEvent = new CustomEvent("kweber-invoice-data-chceck");

    this.orderPricesCalculator = new OrderPricesCalculator();
    // this.validate = new OrderInvoiceDataPopup(this);

    this.error = false;

    return true;
  }

  setupEvents() {
    this.form.addEventListener("submit", evt => this.handleSubmit(evt));
  }

  handleSubmit(evt) {
    evt.preventDefault();

    if (!this.orderPricesCalculator.update()) {
      return false;
    }

    const billType = this.form.querySelector(".billType:checked").value;

    this.submit.disabled = true;

    if (billType === "invoice") {
      this.submit.innerText = "Sprawdzam dane...";
      this.validateUserData();
    } else {
      this.invoiceDataCheckOk();
    }
  }

  validateUserData() {
    axios.post(this.checkAction, {})
    .then((response) => {
      if (!response || response.status !== 200) {
        throw new Error(response.statusText);
      } else {
        if (response.data.message === 'OK') {
          this.invoiceDataCheckOk();
        } else {
          this.invoiceDataCheckError();
          this.showPopup();
        }
      }
    })
    .catch((error) => {
      document._kweber.toast({
        type: 'error',
        title: 'Błąd walidacji danych faktury'
      });
    });
  }

  invoiceDataCheckOk() {
    this.error = false;
    const data = this.buildData();
    if (!this.error) {
      this.submit.innerText = "Wysyłam...";
      this.send(data);
    }
  }

  invoiceDataCheckError() {
    this.submit.innerText = "Płacę";
    this.submit.disabled = false;
  }

  buildData() {
    this.advertisesArray = [];
    this.productsArray = [];

    Array.from(this.productsInputs).forEach((el, index) => {
      if (parseInt(el.value) !== -1) {
        this.productsArray.push(el.value);
        this.advertisesArray.push(this.advertiseInputs[index].value);
      }
    });

    const billType = this.form.querySelector(".billType:checked").value;
    const paymentMethod = this.form.querySelector(
      ".paymentMethods__input:checked"
    ).value;

    if (!billType || !paymentMethod) {
      document._kweber.toast({
        type: "error",
        title: "Błąd danych formularza"
      });

      this.error = true;
    }

    const data = {
      advertises: this.advertisesArray,
      products: this.productsArray,
      billType: billType,
      paymentMethod: paymentMethod
    };

    return data;
  }

  send(data) {
    axios
      .post(this.action, data)
      .then(response => {
        if (!response || response.status !== 200) {
          throw new Error(response.statusText);
        } else {
          window.location.assign(response.data.link);
        }
      })
      .catch(error => {
        document._kweber.toast({
          type: "error",
          title: "Błąd zamówienia"
        });
      });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Forms/Order.js